// METIS Hub wording — namespace "people" (ko), 372 keys.
// Extracted once from the approved mockup (poc-plan/mockup-src: js/screens/people.js App.addI18n).
// From now on this file is the source: edit it by hand (keep ko/en keys in pairs — packages/i18n tests check
// key parity, Hangul in English text and the plan 9.1.3 wording rules). Placeholders: {name}, plural {n|one|other}.
const people: Record<string, string> = {
  "people.list.teamFilterReset": "고른 팀은 소집단 보호 대상이라 모든 허용 팀으로 조회했어요.",
  "people.kicker.all": "회사 전체",
  "people.kicker.allTeam": "전체 · {team}만",
  "people.kicker.team": "우리 팀 · {team}",
  "people.title.all": "회사 전체 사람·팀",
  "people.title.team": "{team} 사람·팀",
  "people.desc": "{range} · 한국 시간 · 기준 {asof}",
  "people.thisMonth": "이번 달",
  "people.thisMonth.title": "{from}부터 오늘까지로 기간을 바꿔요",
  "people.invite.btn": "사람 초대",
  "people.rule.title": "기록 당시 소속으로 봐요",
  "people.rule.team": "팀을 옮긴 사람은 우리 팀에 있던 동안의 기록만 보여요. 같은 팀의 다른 매니저·관리자·원문 열람 담당의 기록은 보이지 않아요{ex}.",
  "people.rule.teamEx": "(지금 {n}명)",
  "people.rule.filter": "팀을 고르면 그 팀에 있던 동안의 기록만 모아요. 옮겨 간 사람은 그 전 기록만, 옮겨 온 사람은 그 뒤 기록만 보여요.",
  "people.me.title": "사람·팀은 ‘{scope}’ 범위에서 봐요",
  "people.me.body": "지금 보기 범위가 ‘나’라서 다른 사람의 기록이 보이지 않아요. 보기 범위를 바꾸면 팀과 사람별로 비교해 볼 수 있어요.",
  "people.me.to": "‘{scope}’ 범위로 보기",
  "people.me.self": "내 상세 보기",
  "people.noTeam.title": "이 팀을 볼 권한이 없어요",
  "people.noTeam.desc": "지금 역할({role})은 맡은 팀({mine})만 볼 수 있어요. {team} 기록이 필요하면 관리자에게 요청하세요.",
  "people.noTeam.back": "우리 팀 보기",
  "people.tabs.label": "사람·팀 보기",
  "people.tab.teams": "팀",
  "people.tab.people": "사람",
  "people.tab.invite": "초대",
  "people.tab.service": "서비스 계정",
  "people.teams.q": "팀별로 얼마나 쓰나요?",
  "people.teams.tech": "{metric} · 이름순(순위 아님) · CLI 채움 / API 빗금",
  "people.teams.sum": "{n}개 팀에서 {u}명이 이 기간에 AI를 썼어요.",
  "people.teams.row": "활성 {a}/{m}명 · 질문 {p}",
  "people.teams.rowSmall": "{t}개 팀 · 활성 {a}/{m}명 · 질문 {p}",
  "people.teams.rowSmallHidden": "3명보다 적은 팀 합산 · 합쳐도 3명보다 적어 값을 가렸어요",
  "people.teams.hiddenTech": "{teams} · {n}명 · 소집단 보호",
  "people.teams.hiddenSum": "고른 팀이 3명보다 적어 팀 값을 가렸어요. 모든 팀을 보면 ‘소규모 팀 합산’ 한 줄로 보여요.",
  "people.teams.allTeams": "모든 팀 보기",
  "people.teams.small": "소규모 팀 합산",
  "people.teams.smallNote": "3명보다 적은 팀은 ‘소규모 팀 합산’ 한 줄로 묶어요. 묶인 팀이 하나뿐이거나 합쳐도 3명보다 적으면 그 줄의 값도 가려요.",
  "people.teams.opt.metric": "지표",
  "people.teams.opt.periodHelp": "기간을 바꾸면 사람·팀 화면 전체 기간이 함께 바뀌어요.",
  "people.teams.col.team": "팀",
  "people.teams.col.members": "사람",
  "people.teams.col.active": "활성",
  "people.teams.col.prompts": "질문",
  "people.teams.col.tokens": "사용량",
  "people.teams.col.sessions": "대화",
  "people.teams.toPeople": "{team} 사람 보기",
  "people.empty.next30": "30일로 넓혀 보기",
  "people.ratio.q": "CLI 도구와 API 키 호출은 팀마다 어떤 비율인가요?",
  "people.ratio.tech": "사용 방식 비율 · 100% 막대 · CLI 채움 / API 빗금",
  "people.ratio.sum": "사용량의 {p}가 CLI 도구예요.",
  "people.ratio.sumCount": "질문·호출의 {p}가 CLI 도구예요.",
  "people.ratio.tokens": "사용량(토큰)",
  "people.ratio.count": "질문·호출",
  "people.ratio.none": "이 기간 기록 없음",
  "people.cost.q": "비용은 팀마다 어떻게 나뉘나요?",
  "people.cost.tech": "비용 종류별 · 서로 더하지 않아요 · 청구서 아님",
  "people.cost.sum": "CLI 도구 추정 비용은 {a}, 단가표 계산 비용은 {b}예요. 종류가 달라 더하지 않아요.",
  "people.cost.col.cli": "CLI 도구 추정",
  "people.cost.col.unofficial": "Codex 비공식",
  "people.cost.col.gw": "단가표 계산",
  "people.cost.col.org": "조직 보고서",
  "people.cost.orgNote": "조직 보고서는 팀이 가진 API 키 기준이에요 · 청구 기준 · 하루 단위 · 사람별 아님",
  "people.cost.mobileNote": "Codex 비공식·조직 보고서 비용은 넓은 화면에서 보여요.",
  "people.list.q": "사람마다 얼마나 쓰나요?",
  "people.list.tech": "질문·사용량 · {period} · {sort}",
  "people.list.sum": "{n}명 중 {a}명이 이 기간에 AI를 썼어요.",
  "people.list.sumConn": "연결을 살펴볼 사람이 {b}명 있어요.",
  "people.list.sumFormer": "다른 팀으로 옮기기 전 기록이 있는 {f}명도 함께 보여요.",
  "people.list.sumSmall": "기록이 있는 사람이 3명보다 적어 사람별 값을 가렸어요.",
  "people.list.sumFiltered": "조건에 맞는 {n}명을 보여요.",
  "people.list.none": "조건에 맞는 사람이 없어요.",
  "people.list.noneNot": "찾는 말을 지우거나 조건을 풀어 보세요.",
  "people.list.clear": "조건 지우기",
  "people.list.range": "{from}–{to} / {n}명",
  "people.pager": "사람 목록 쪽 이동",
  "people.sort.label": "정렬",
  "people.sort.name": "이름순",
  "people.sort.tokens": "사용량순",
  "people.sort.cost": "비용순",
  "people.sort.byName": "이름순(순위 아님)",
  "people.sort.byValue": "값순(순위 아님)",
  "people.sort.off": "값순 정렬은 꺼져 있어요(기록 정책 · 기본 끔). 사람을 줄 세우지 않으려는 장치예요.",
  "people.sort.offLink": "기록 정책 보기",
  "people.sort.offTip": "기록 정책에서 ‘사람 값순 정렬 허용’을 켜야 써요",
  "people.sort.scopeTip": "이 지표는 열람 범위나 소집단 보호 때문에 정렬할 수 없어요",
  "people.sort.on": "값순으로 정렬했어요. 순위가 아니라 비용·보안 관리를 위한 숫자예요. 비용순은 CLI 도구 추정 비용 기준이에요.",
  "people.search.label": "사람 찾기",
  "people.search.ph": "이름·팀·역할로 찾기",
  "people.filter.label": "조건",
  "people.filter.attention": "연결을 살펴볼 사람만",
  "people.col.name": "이름",
  "people.col.role": "역할",
  "people.col.team": "팀",
  "people.col.use": "질문·사용량",
  "people.col.cost": "추정 비용",
  "people.col.tool": "주로 쓰는 도구",
  "people.col.last": "마지막 사용",
  "people.col.conn": "연결 상태",
  "people.row.prompts": "질문 {n}",
  "people.row.noUse": "이 기간 기록 없음",
  "people.row.never": "기록 없음",
  "people.row.former": "{date}에 {team}{ro} 옮김 · 그 전 기록만",
  "people.row.joined": "{date}에 옮겨 옴 · 그 뒤 기록만",
  "people.row.nowTeam": "지금 {team}",
  "people.rule.more": "매니저 범위란?",
  "people.d.api.keysHidden": "가진 API 키 {n}개 · 별칭과 끝 4자리는 키 보기 권한이 있어야 보여요.",
  "people.row.disabled": "비활성",
  "people.row.reconsent": "재동의 필요",
  "people.row.paused": "일시 중지 중",
  "people.row.pending": "승인 대기",
  "people.row.noConn": "연결 없음",
  "people.row.moreConn": "외 {n}개",
  "people.row.audit": "열람·변경 이력",
  "people.row.select": "{name} 고르기",
  "people.row.selectAll": "보이는 사람 모두 고르기",
  "people.cost.cli": "CLI 추정",
  "people.cost.gw": "단가표",
  "people.cost.unofficial": "Codex 비공식",
  "people.cost.none": "이 기간 비용 없음",
  "people.legend.note": "막대 길이는 사용량(토큰)이에요. CLI 도구는 채움, API 키 호출은 빗금이에요.",
  "people.mobileAdmin": "초대·역할·팀·비활성화는 PC에서 해 주세요.",
  "people.bulk.label": "묶음 작업",
  "people.bulk.count": "{n}명 선택",
  "people.bulk.role": "역할 바꾸기",
  "people.bulk.team": "팀 옮기기",
  "people.bulk.disable": "비활성화",
  "people.bulk.enable": "다시 켜기",
  "people.bulk.clear": "선택 해제",
  "people.bulk.teamOff": "위임받은 팀 밖으로는 옮길 수 없어요",
  "people.role.title": "역할 바꾸기",
  "people.role.kicker": "{n}명",
  "people.role.pick": "새 역할",
  "people.role.expiry": "만료일",
  "people.role.expiryHint": "글을 볼 수 있는 역할은 만료일이 꼭 있어야 해요.",
  "people.role.reason": "바꾸는 이유",
  "people.role.reasonPh": "예: 플랫폼팀 매니저 지정(조직 개편)",
  "people.role.reasonHint": "2인 승인이 필요한 변경은 10자 이상 적어 주세요.",
  "people.role.preview": "누구에게 어떻게 적용되나요?",
  "people.role.out.now": "바로 바뀌어요",
  "people.role.out.dual": "2인 승인 필요 · {perm}({scope})",
  "people.role.out.same": "이미 이 역할이에요",
  "people.role.out.self": "자기 역할은 바꿀 수 없어요",
  "people.role.out.lastAdmin": "마지막 관리자는 바꿀 수 없어요",
  "people.role.out.higher": "나보다 넓은 권한을 가진 사람이에요",
  "people.role.out.scope": "위임받은 팀 밖의 사람이에요",
  "people.role.out.perm": "사람 관리 권한이 없어요",
  "people.role.out.disabled": "비활성화된 사람이에요",
  "people.role.rules": "자기 권한은 올릴 수 없고, 내가 가진 범위 안에서만 줄 수 있어요. 글·실명·내보내기 권한이 늘어나면 2인 승인과 안내문 ‘누가 볼 수 있나요’ 갱신이 함께 필요해요.",
  "people.role.session": "바뀌면 대상자의 로그인이 다시 시작돼요.",
  "people.role.apply": "바꾸기",
  "people.role.err.reason": "2인 승인이 필요한 변경은 이유를 10자 이상 적어 주세요.",
  "people.role.err.none": "바꿀 수 있는 사람이 없어요.",
  "people.role.err.expiry": "만료일을 정해 주세요.",
  "people.role.done": "{n}명의 역할을 바꿨어요. 대상자의 로그인이 다시 시작돼요.",
  "people.role.doneDual": "{n}명은 2인 승인을 기다려요(요청자와 승인자는 달라야 해요).",
  "people.team.title": "팀 옮기기",
  "people.team.pick": "새 팀",
  "people.team.when": "오늘({date})부터 적용돼요.",
  "people.team.rule": "기록 당시 소속 규칙: 옮기기 전 기록은 옛 팀 매니저가, 옮긴 뒤 기록은 새 팀 매니저가 봐요. 지난 기록의 소속은 바뀌지 않아요.",
  "people.team.apply": "옮기기",
  "people.team.same": "이미 이 팀이에요",
  "people.team.done": "{n}명을 {team}{ro} 옮겼어요. 매니저가 볼 수 있는 범위가 바로 바뀌어요.",
  "people.disable.title": "{n}명을 비활성화할까요?",
  "people.disable.b1": "로그인과 모든 연결 토큰이 바로 막혀요.",
  "people.disable.b2": "기록은 보관 기간대로 남아요. 지우려면 삭제 요청을 따로 처리해요.",
  "people.disable.b3": "다시 켤 수 있지만 도구는 다시 연결해야 해요.",
  "people.disable.apply": "비활성화",
  "people.disable.done": "{n}명을 비활성화했어요. 연결 토큰 {k}개를 폐기했어요.",
  "people.enable.title": "{n}명을 다시 켤까요?",
  "people.enable.b1": "다시 로그인할 수 있어요. 폐기한 연결 토큰은 되살아나지 않아요.",
  "people.enable.apply": "다시 켜기",
  "people.enable.done": "{n}명을 다시 켰어요. 도구는 다시 연결해야 해요.",
  "people.inv.title": "사람 초대",
  "people.inv.kicker": "초대 코드",
  "people.inv.email": "회사 메일",
  "people.inv.emailPh": "name@example.com",
  "people.inv.emailHint": "허용 도메인(example.com) 주소만 초대할 수 있어요.",
  "people.inv.team": "팀",
  "people.inv.teamHint": "사람은 팀에 속해요. 본부(팀을 묶는 단위)는 고를 수 없어요.",
  "people.inv.noTeam": "사람을 넣을 수 있는 팀이 없어요.",
  "people.inv.noTeam.groups": "본부(팀을 묶는 단위)에는 사람을 넣을 수 없어요: {groups}. 본부를 일반 팀으로 바꾸거나, 본부 아래에 팀을 만들어 주세요.",
  "people.inv.noTeam.none": "아직 만든 팀이 없어요. 팀을 먼저 만들어 주세요.",
  "people.inv.noTeam.ask": "팀을 만들거나 바꿀 권한이 없어요. 관리자에게 팀 구성을 요청하세요.",
  "people.inv.noTeam.ungroup": "‘{team}’{eul} 일반 팀으로 바꾸기",
  "people.inv.noTeam.tree": "팀 구성으로 가기",
  "people.inv.noTeam.ungrouped": "‘{team}’{eul} 일반 팀으로 바꿨어요. 이제 이 팀을 고를 수 있어요.",
  "people.inv.role": "시작 역할",
  "people.inv.roleVal": "일반 사용자(초대·자동 가입의 기본 역할)",
  "people.inv.roleHint": "다른 역할은 가입한 뒤 ‘역할 바꾸기’로 줘요.",
  "people.inv.make": "초대 코드 만들기",
  "people.inv.err.email": "메일 주소 형식이 맞지 않아요.",
  "people.inv.err.domain": "허용 도메인(example.com) 주소만 초대할 수 있어요.",
  "people.inv.err.dup": "이미 초대했거나 가입한 주소예요.",
  "people.inv.done.title": "초대 코드를 만들었어요",
  "people.inv.done.lead": "{email}에게 아래 코드를 보내 주세요. 코드는 지금 한 번만 보여요.",
  "people.inv.done.exp": "{date}까지 7일 동안 쓸 수 있어요 · 가입하면 일반 사용자로 시작해요.",
  "people.inv.done.next": "가입한 뒤 첫 로그인에서 기록 수준을 고르고 도구를 연결해요.",
  "people.inv.toast": "초대 코드를 만들었어요. ‘초대’ 탭에서 상태를 볼 수 있어요.",
  "people.inv.paths": "계정이 생기는 길: 관리자가 만든 계정(임시 비밀번호) · 초대 코드 · Google 첫 로그인(일반 사용자, 허용 도메인).",
  "people.invTab.q": "초대한 사람은 가입했나요?",
  "people.invTab.tech": "초대 코드 · 7일 동안 유효 · {scope}",
  "people.invTab.sum": "가입 대기 {p}건 · 가입 {a}건 · 만료·취소 {e}건이에요.",
  "people.invTab.col.email": "메일",
  "people.invTab.col.team": "팀",
  "people.invTab.col.role": "시작 역할",
  "people.invTab.col.by": "초대한 사람",
  "people.invTab.col.sent": "보낸 때",
  "people.invTab.col.exp": "만료",
  "people.invTab.col.status": "상태",
  "people.invTab.col.act": "할 일",
  "people.inv.st.pending": "가입 대기",
  "people.inv.st.accepted": "가입함",
  "people.inv.st.expired": "만료",
  "people.inv.st.canceled": "취소함",
  "people.inv.resend": "다시 보내기",
  "people.inv.cancel": "취소",
  "people.inv.resent": "새 코드를 만들어 다시 보냈어요(7일).",
  "people.inv.canceled": "초대를 취소했어요. 그 코드는 더 쓸 수 없어요.",
  "people.inv.code": "코드 {code}",
  "people.inv.acceptedAt": "{date} 가입",
  "people.invTab.empty": "보낸 초대가 없어요.",
  "people.invTab.emptyNot": "초대하지 않아도 허용 도메인 메일이면 Google 첫 로그인으로 가입할 수 있어요.",
  "people.svc.q": "사람이 아닌 계정은 무엇이 있나요?",
  "people.svc.tech": "서비스 계정 · 소유자·용도·만료·전용 토큰",
  "people.svc.sum": "서비스 계정 {n}개 · 가장 빠른 만료는 {date}({name})예요.",
  "people.svc.col.name": "이름",
  "people.svc.col.purpose": "용도",
  "people.svc.col.owner": "소유자",
  "people.svc.col.team": "팀",
  "people.svc.col.token": "전용 토큰",
  "people.svc.col.exp": "만료",
  "people.svc.col.last": "마지막 사용",
  "people.svc.col.status": "상태",
  "people.svc.note": "사람이 아닌 주체예요. 사용량은 소유자에게 보이고, 동의 대상이 아니에요.",
  "people.svc.manage": "만들기·만료 연장은 역할·권한 화면에서 해요.",
  "people.svc.left": "{d}일 남음",
  "people.svc.empty": "서비스 계정이 없어요.",
  "people.svc.emptyNot": "사내 앱·CI가 AI를 부르면 사람 대신 서비스 계정으로 연결해요.",
  "people.conn.q": "연결을 살펴볼 사람이 있나요?",
  "people.conn.tech": "연결 상태 · 오류 → 연결 안 됨 → 한동안 조용함 순",
  "people.conn.sum": "연결 {n}개 중 {b}개를 살펴보세요(오류 {p} · 연결 안 됨 {d} · 한동안 조용함 {q}).",
  "people.conn.sumOk": "연결 {n}개가 모두 잘 보내고 있어요.",
  "people.conn.more": "그 밖에 {n}개가 더 있어요.",
  "people.conn.idle": "3일 넘게 받은 기록이 없으면 ‘연결 안 됨’이에요. 쓰지 않았다면 괜찮아요.",
  "people.conn.last": "마지막 수신 {rel}",
  "people.conn.go": "도구 연결에서 보기",
  "people.conn.none": "연결한 도구가 없어요.",
  "people.d.navTitle": "사람 상세",
  "people.d.kicker": "사람 상세",
  "people.d.q": "이 사람은 AI를 어떻게 쓰나요?",
  "people.d.view.title": "이 화면을 연 기록이 남고 당사자에게 표시돼요",
  "people.d.view.body": "열람·변경 이력에 ‘개인별 보기’로 남았어요({time}). 당사자는 ‘누가 내 기록을 봤나요’에서 열람한 역할과 시각을 봐요.",
  "people.d.view.self": "내 상세예요. 내 기록은 열람 이력이 남지 않아요.",
  "people.d.moved.title": "{date}에 {team}{ro} 옮긴 사람이에요",
  "people.d.moved.body": "기록 당시 소속 규칙에 따라 {old}에 있던 동안({until}까지)의 기록만 보여요. 지금 연결·기록 수준은 볼 수 없어요.",
  "people.d.joined.title": "{date}에 {old}에서 옮겨 온 사람이에요",
  "people.d.joined.body": "기록 당시 소속 규칙에 따라 옮겨 온 뒤의 기록만 보여요. 그 전 기록은 {old} 매니저가 봐요.",
  "people.d.disabled.title": "비활성화된 사람이에요",
  "people.d.disabled.body": "로그인과 연결 토큰이 막혀 있어요. 기록은 보관 기간대로 남아요.",
  "people.d.f.team": "팀",
  "people.d.f.manager": "매니저",
  "people.d.f.role": "역할",
  "people.d.f.level": "기록 수준",
  "people.d.f.conn": "연결",
  "people.d.f.last": "마지막 사용",
  "people.d.f.job": "직무",
  "people.d.f.connLine": "{n}개 · 살펴볼 연결 {b}개",
  "people.d.f.connOk": "{n}개 · 모두 괜찮아요",
  "people.d.f.connNone": "연결 없음",
  "people.d.f.reconsent": "재동의 필요({v} 기준)",
  "people.d.f.paused": "일시 중지 중({from}~{to})",
  "people.d.f.noManager": "지정된 매니저 없음",
  "people.d.cli.q": "CLI 도구로 얼마나 썼나요?",
  "people.d.cli.tech": "CLI 도구 · Claude Code · Codex",
  "people.d.cli.def": "AI 코딩 도구 Claude Code·Codex를 쓴 기록이에요. 결제 방식(구독 로그인·API 키)과 상관없이 여기에 모여요.",
  "people.d.cli.sum": "질문은 {s}",
  "people.d.cli.sumOnly": "질문 {n}을 보냈어요.",
  "people.d.cli.empty": "이 기간에 받은 CLI 도구 기록이 없어요.",
  "people.d.m.costCli": "도구 추정 비용",
  "people.d.m.calls": "호출 수",
  "people.d.m.costApi": "단가표 계산 비용",
  "people.d.m.latency": "응답 대기",
  "people.d.latency": "보통 {a} · 느릴 때 {b}",
  "people.d.latA": "보통 {a}",
  "people.d.latB": "느릴 때 {b}",
  "people.d.cli.sub": "AI 코딩 도구 Claude Code·Codex 사용, 결제 방식과 무관",
  "people.d.api.sub": "앱·스크립트가 회사 게이트웨이를 거쳐 부른 호출",
  "people.d.noTime": "AI 사용 시간과 시간대는 사람별로 보여 주지 않아요(팀 합계로만).",
  "people.d.noSum": "서로 더하지 않아요",
  "people.d.auth": "결제 방식: 구독 로그인 {s} · API 키 {k} · 확인 안 됨 {u}",
  "people.d.authNote": "대화 수 기준 · Claude는 기기마다 마지막으로 확인한 방식이에요",
  "people.d.gw": "CLI(게이트웨이 경유) {n}건 · 중복 확인 중",
  "people.d.gwHelp": "PC에서 보낸 기록에 같은 호출이 있는지 확인하기 전까지 어느 카드에도 더하지 않아요. 없으면 약 10분 뒤 합계에 들어와요.",
  "people.d.toolRow": "질문 {p} · {tok}",
  "people.d.toolRowApi": "호출 {c} · {tok}",
  "people.d.api.q": "API 키로 얼마나 불렀나요?",
  "people.d.api.tech": "API 키 호출 · 회사 게이트웨이",
  "people.d.api.def": "앱·스크립트가 회사 게이트웨이를 거쳐 AI를 부른 호출이에요. 게이트웨이를 거친 호출만 사람별로 보여요.",
  "people.d.api.sum": "호출은 {s}",
  "people.d.api.sumOnly": "호출 {n}을 보냈어요.",
  "people.d.api.keys": "가진 API 키",
  "people.d.api.noKeys": "가진 API 키가 없어요.",
  "people.d.api.org": "키 {k}개 · {days}일 · 사용량 {tok} · {usd}",
  "people.d.api.orgNote": "가진 키 기준 · 하루 단위 · 사람별 아님 · 위 숫자와 더하지 않아요",
  "people.d.api.empty": "게이트웨이를 거친 API 키 호출 기록이 없어요.",
  "people.d.api.emptyNot": "게이트웨이를 거친 호출만 사람별로 보여요. API 키를 안 쓴 건 아닐 수 있어요.",
  "people.d.daily.q": "날마다 얼마나 썼나요?",
  "people.d.daily.tech": "{metric} · 사용 방식별 누적 · 점선은 직전 기간",
  "people.d.daily.peak": "가장 많이 쓴 날은 {day}{ie}({v}).",
  "people.d.daily.peakWeek": "가장 많이 쓴 주는 {day}{ie}({v}).",
  "people.d.recent.q": "최근에 어떤 대화를 했나요?",
  "people.d.recent.tech": "대화 · 최근 {n}건 · 남의 기록은 대화 번호로만 보여요",
  "people.d.recent.sum": "가장 최근 대화는 {rel}에 시작했어요.",
  "people.d.recent.all": "사용 기록에서 보기",
  "people.d.col.title": "대화",
  "people.d.col.when": "시각",
  "people.d.col.tool": "도구",
  "people.d.col.prompts": "질문",
  "people.d.col.tokens": "사용량",
  "people.d.col.level": "기록 수준",
  "people.d.col.peek": "첫 질문",
  "people.d.peek": "보기",
  "people.d.peekClose": "닫기",
  "people.d.peekAria": "대화 #{no}의 첫 질문 보기",
  "people.d.pv.title": "대화 #{no} · 첫 질문",
  "people.d.pv.left": "남은 시간 {min}분",
  "people.d.pv.noPerm": "이 역할은 이 사람의 질문 글을 볼 수 없어요. 매니저는 기본적으로 팀원의 글을 볼 수 없어요.",
  "people.d.pv.flow": "남의 글은 사유 → 다시 로그인 확인 → 대화 단위 허가(60분)를 거쳐 열려요. 열면 당사자에게 표시돼요.",
  "people.d.pv.own": "내 기록이라 바로 보여요.",
  "people.d.pv.empty": "이 대화에는 질문 글이 없어요(명령만 보냈어요).",
  "people.d.conn.q": "도구 연결은 괜찮나요?",
  "people.d.conn.tech": "연결 상태 · 마지막 수신 기준",
  "people.d.conn.sumOk": "연결 {n}개가 모두 잘 보내고 있어요.",
  "people.d.conn.sumSome": "연결 {n}개 중 {bad}개를 살펴보세요.",
  "people.d.conn.none": "아직 연결한 도구가 없어요.",
  "people.d.conn.noneNot": "연결하기 전 기록은 남지 않아요. 연결하면 다음 질문부터 기록돼요.",
  "people.d.conn.ver": "CLI {v}",
  "people.d.conn.token": "수집 전용 토큰 {p}…",
  "people.d.conn.revoke": "연결 끊기",
  "people.d.conn.revokeTitle": "이 연결을 끊을까요?",
  "people.d.conn.revokeBody": "{device}의 {tool} 수집 전용 토큰을 폐기해요. 그 PC가 보내는 기록은 바로 거부되고, 다시 쓰려면 도구를 새로 연결해야 해요.",
  "people.d.conn.revoked": "연결을 끊었어요. 열람·변경 이력에 남았어요.",
  "people.d.conn.scope": "지금 소속 팀이 달라서 연결 목록은 볼 수 없어요.",
  "people.d.conn.at": "{date} 끊음",
  "people.d.role.q": "어느 팀에서 어떤 역할을 맡고 있나요?",
  "people.d.role.tech": "역할·팀 · 팀 이동 이력 · 기록 당시 소속",
  "people.d.role.sum": "{team}에서 {roles} 역할을 맡고 있어요.",
  "people.d.role.sumFormer": "{team}에서 옮겨 간 사람이에요. 지금 역할·연결은 {now} 매니저와 관리자가 봐요.",
  "people.d.role.grants": "역할 부여",
  "people.d.role.g.role": "역할",
  "people.d.role.g.teams": "적용 팀",
  "people.d.role.g.at": "준 날",
  "people.d.role.g.by": "준 사람",
  "people.d.role.g.appr": "승인",
  "people.d.role.g.exp": "만료",
  "people.d.role.g.base": "모든 사람이 함께 가진 기본 역할",
  "people.d.role.g.all": "전체",
  "people.d.role.g.none": "없음",
  "people.d.role.g.never": "정하지 않음",
  "people.d.role.hist": "팀 이동 이력",
  "people.d.role.now": "지금",
  "people.d.role.self": "자기 역할·팀은 바꿀 수 없어요. 다른 관리자에게 요청하세요.",
  "people.d.role.pc": "역할·팀은 PC에서 바꿔 주세요.",
  "people.d.role.system": "시스템",
  "people.d.aud.q": "이 사람 기록은 누가 봤나요?",
  "people.d.aud.tech": "열람·변경 이력 · 글 열람·개인별 보기·내보내기·삭제·법적 보관 · 최근 {n}건",
  "people.d.aud.sum": "최근 {n}건 중 글 열람 {c}건(거부 {d}건) · 개인별 보기 {p}건이에요.",
  "people.d.aud.go": "열람·변경 이력에서 보기",
  "people.d.aud.note": "당사자는 ‘누가 내 기록을 봤나요’에서 열람한 역할·시각·사유를 봐요. 고치거나 지울 수 없어요.",
  "people.d.aud.col.when": "시각",
  "people.d.aud.col.kind": "무엇을",
  "people.d.aud.col.actor": "누가(역할)",
  "people.d.aud.col.target": "대상·사유",
  "people.d.aud.col.result": "결과",
  "people.d.aud.conv": "대화 #{no}",
  "people.d.aud.noReason": "사유 입력 대상 아님",
  "people.d.aud.empty": "아직 이 사람 기록을 연 이력이 없어요.",
  "people.d.aud.emptyNot": "열면 성공·거부 모두 이력에 남아요.",
  "people.d.nf.title": "이 사람을 찾을 수 없어요",
  "people.d.nf.desc": "없는 사람이거나 지금 역할로 볼 수 있는 범위 밖이에요. 필요하면 관리자에게 요청하세요.",
  "people.d.nf.back": "사람·팀으로",
  "people.d.np.desc": "사람 상세는 개인별 상세 보기 권한이 있어야 열려요. 지금 역할({role})로는 볼 수 없어요.",
};

export default people;
